var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3453_6157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1934 0.826172H2.81836C1.43765 0.826172 0.318359 2.00142 0.318359 3.45117V18.5449C0.318359 19.9947 1.43765 21.1699 2.81836 21.1699H27.1934C28.5741 21.1699 29.6934 19.9947 29.6934 18.5449V3.45117C29.6934 2.00142 28.5741 0.826172 27.1934 0.826172Z",
    fill: "white",
    stroke: "black",
    strokeOpacity: 0.2,
    strokeWidth: 0.626857
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49345 8.26123C2.83953 7.88464 2.09321 7.58175 1.25879 7.37156L1.29379 7.20788H4.71501C5.17874 7.22495 5.55503 7.37145 5.67747 7.88884L6.421 11.6109L6.64877 12.732L8.73125 7.20788H10.9798L7.63739 15.3003H5.38875L3.49345 8.26123ZM12.6338 15.3089H10.5073L11.8373 7.20788H13.9637L12.6338 15.3089ZM20.3423 7.40593L20.0531 9.15524L19.8607 9.06922C19.476 8.90542 18.9681 8.74174 18.2768 8.75903C17.4372 8.75903 17.0607 9.11217 17.052 9.45695C17.052 9.8362 17.5074 10.0861 18.2512 10.4568C19.4763 11.0342 20.0446 11.7408 20.0361 12.663C20.0189 14.3436 18.5663 15.4296 16.3351 15.4296C15.3811 15.4209 14.4623 15.2223 13.9635 14.9985L14.2611 13.18L14.5411 13.3094C15.2324 13.6113 15.6873 13.7403 16.5363 13.7403C17.1485 13.7403 17.8049 13.4902 17.8133 12.9474C17.8133 12.5941 17.5336 12.3353 16.7109 11.9389C15.906 11.5509 14.8298 10.9047 14.8473 9.74113C14.8564 8.16409 16.3351 7.06104 18.435 7.06104C19.2576 7.06104 19.9228 7.24201 20.3423 7.40593ZM23.1685 12.439H24.936C24.8485 12.034 24.4458 10.0948 24.4458 10.0948L24.2972 9.39681C24.1922 9.69841 24.0086 10.1897 24.0174 10.1724C24.0174 10.1724 23.3436 11.9736 23.1685 12.439ZM25.7933 7.20788L27.5088 15.3088H25.5399C25.5399 15.3088 25.3472 14.378 25.2862 14.0936H22.556C22.4771 14.3089 22.1097 15.3088 22.1097 15.3088H19.8785L23.0371 7.88002C23.2559 7.35427 23.6413 7.20788 24.1485 7.20788H25.7933Z",
    fill: "#171E6C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3453_6157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.62ae5f7574ab69c803fb3c75c004617f.svg";
export { ForwardRef as ReactComponent };